interface EmotionalHeatmapProps {
  organizationFilter?: string
  trackerFilter?: string
}

export function EmotionalHeatmap({ organizationFilter, trackerFilter }: EmotionalHeatmapProps) {
  return null
}
